<template>
    <div class='events-section'>
        <div class="details box is-radiusless is-marginless is-shadowless">
            <h4 class="is-size-5">Projektbegivenheder</h4>
            <br>

            <ul class="events" v-if="projectEvents.length">
                <li v-for="event in projectEvents" class="event">
                    <h6 class="event-title">{{$t(`projects.events.${event.type}`)}}</h6>

                    <div class="event-account level">
                        <div class="level-left">
                            <avatar :account="event.account" :size="24" round/>
                            <small class="event-account__name">{{event.account.name}}</small>
                        </div>

                        <div class="level-right">
                            <small>{{event.created_at | formatShortDateTime}}</small>
                        </div>
                    </div>
                </li>
            </ul>

            <p v-else-if="isLoading">
                Indlæser begivenheder...
            </p>

            <p v-else>
                Kunne ikke finde nogen begivenheder.
            </p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

    .events {
        .event {
            margin-bottom: 10px;

            .event-title {
                font-weight: bold;
                margin-bottom: 5px;
            }

            .event-account {
                .event-account__name {
                    margin-left: 5px;
                }
            }
        }
    }
</style>

<script>
    import Avatar from '@/taskflex/users/components/Avatar';
    import ProjectEventsService from '@/taskflex/projects/services/ProjectEventsService';

    export default {
        data() {
            return {
                isLoading: false,
                projectEvents: [],
            };
        },

        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        watch: {
            project() {
                this.loadEvents();
            },
        },

        mounted() {
            this.loadEvents();

            // join project-event-channel 'projects.ID.events'
        },

        methods: {
            loadEvents() {
                const options = {
                    includes: ['account'],

                    sort: [
                        {
                            key: 'created_at',
                            direction: 'asc',
                        },
                    ],
                };

                this.isLoading = true;

                ProjectEventsService.findAll(this.project.id, options, ({ data: { rows } }) => {
                    this.isLoading = false;

                    this.projectEvents = rows;
                });
            },
        },

        components: {
            Avatar,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectEvents.vue